import {
    SET_DATATABLE,
    INVALIDATE_DATATABLE_FILTERS,
    REMOVE_DATATABLE,
    UPDATE_DATATABLE_SEARCH,
    REMOVE_DATATABLE_SEARCH,
    SET_DATATABLE_LOADING,
    REMOVE_DATATABLE_LOADING,
    UPDATE_DATATABLE_ORDER,
    DATATABLE_DOWNLOADING,
    DATATABLE_UPDATING,
    SET_DATATABLE_CONFIRM_STATE,
    REMOVE_DATATABLE_CONFIRM_STATE,
    REFRESH_DATATABLE_UPDATED_AT,
    DATATABLE_CONFIRM_ON_CHANGE,
    SET_DATATABLE_CURRENT_PAGE
} from "../../types";

const initialState = {
    reactAPI: true, //   This serves the purpose of differentia from React and Blade Server side.
    loading: false, //  Initit loading state
    downloading: false, // Downloading state
    save_searches: false,
    updating: false,
    columns: [], //   Pull a template from helpers file and use this as the search columns
    table_headings: [],
    draw: 1, // Waiting for implementation draw the current request
    order: [
        {
            column: 0,
            dir: "desc"
        }
    ],
    currentPage: 1, // current results page
    start: 0, // Offset of results ((page number - 1) * results per page)
    length: 15, // results per page
    search: {
        value: "", // Global search
        regex: false
    },
    recordsTotal: 0, // Total of records with status_code 5
    recordsFiltered: 0, // Records after apply the search filters
    data: [], // Data of recordsFiltered
    columnFiltersLoaded: false,
    columnFiltersRevision: 0,
    columnFilters: {}, // contains CORS and Vendor Names
    endpoint: "",
    confirmState: {
        title: "",
        message: "",
        action_url: "",
        action: "",
        loading_message: "",
        modal_comment: "",
        property_id: ""
    },
    updatedAt: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_DATATABLE:
            return {
                ...state,
                loading: false,
                updating: false,
                ...payload,
            };
        case UPDATE_DATATABLE_SEARCH:
            return {
                ...state,
                ...payload
            };

        case SET_DATATABLE_LOADING:
            return {
                ...state,
                loading: true,
                columnFiltersLoaded: false,
            };
        case REMOVE_DATATABLE_LOADING:
            return {
                ...state,
                loading: false
            };
        case DATATABLE_UPDATING:
            return {
                ...state,
                updating: payload
            };
        case DATATABLE_DOWNLOADING:
            return {
                ...state,
                downloading: payload
            };
        case UPDATE_DATATABLE_ORDER:
            return {
                ...state,
                order: [...payload]
            };
        case REMOVE_DATATABLE_SEARCH:
            return {
                ...state,
                ...payload,
                draw: 1, // Waiting for implementation draw the current request
                order: [
                    {
                        column: 0,
                        dir: "desc"
                    }
                ],
                currentPage: 1, // current results page
                start: 0, // Offset of results ((page number - 1) * results per page)
                length: 15 // result
            };
        case SET_DATATABLE_CONFIRM_STATE:
            return {
                ...state,
                confirmState: { ...payload }
            };
        case DATATABLE_CONFIRM_ON_CHANGE:
            return {
                ...state,
                confirmState: {
                    ...state.confirmState,
                    ...payload
                }
            };
        case SET_DATATABLE_CURRENT_PAGE:
            return {
                ...state,
                currentPage: payload
            };
        case REMOVE_DATATABLE_CONFIRM_STATE:
            return {
                ...state,
                confirmState: {
                    title: "",
                    message: "",
                    action_url: "",
                    action: "",
                    loading_message: "",
                    modal_comment: "",
                    property_id: ""
                }
            };
        case REMOVE_DATATABLE:
            return {
                ...state,
                reactAPI: true, // This serves the purpose of differentia from React and Blade Server side.
                loading: false, // Initit loading state
                download: false,
                updating: false,
                columns: [], //  Pull a template from helpers file and use this as the search columns
                draw: 1, // Waiting for implementation draw the current request
                order: [
                    {
                        column: 0,
                        dir: "desc"
                    }
                ],
                currentPage: 1, // current results page
                start: 0, // Offset of results ((page number - 1) * results per page)
                length: 15, // results per page
                search: {
                    value: "", // Global search
                    regex: false
                },
                recordsTotal: 0, // Total of records with status_code 5
                recordsFiltered: 0, // Records after apply the search filters
                data: [], // Data of recordsFiltered
                columnFiltersLoaded: false,
                columnFilters: {}, // contains CORS and Vendor Names,
                endpoint: "",
                table_headings: []
            };
        case INVALIDATE_DATATABLE_FILTERS:
            return { ...state, columnFiltersLoaded: false, columnFiltersRevision: state.columnFiltersRevision + 1 };
        case REFRESH_DATATABLE_UPDATED_AT:
            return {
                ...state,
                updatedAt: Date.now(),
                columnFiltersRevision: state.columnFiltersRevision + 1,
                columnFiltersLoaded: false
            };
        default:
            return state;
    }
}
